import React from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import InputGroup from "../../../components/atoms/InputGroup";

export default function InputCalendar({onChange, dateval, width,mindate,position }) {

    // Render the DatePicker component with Persian calendar and time picker plugin
    return (
        <DatePicker
            format="YYYY/MM/DD"
            calendarPosition={position}
            onChange={onChange}

            calendar={persian}
            locale={persian_fa}
            value={dateval}
            minDate={mindate}

            render={<CustomRangeInput/>}
        />
    );
}

// CustomRangeInput component for rendering custom input for DatePicker
function CustomRangeInput({ openCalendar, value, width }) {
    return (
        <>
            <InputGroup
                placeholder="22 خرداد 1403"
                iconName={"calendar"}
                onFocus={openCalendar}
                label={"تاریخ ثبت سفارش"}
                value={value}
                readOnly={true}
                width={width}
            />
        </>
    );
}
